/**
 * Product spec filter
 * ---------------------------------------------------------------------------
 * Product pages carry 25-60 spec rows across several cards (#catalog-detail-info),
 * which is a lot to scan for one number. This adds a small "Find a spec" link
 * at the top of the spec area; clicking it reveals a compact field that narrows
 * the rows as you type. A card whose rows all fall away is hidden too, so you
 * never scroll past an empty heading.
 *
 * The spec markup is rendered from the product description and is not touched
 * here beyond a marker class; the control is inserted as a sibling before the
 * accordion, outside its CSS columns, and takes over the accordion's top rule
 * (see .has-spec-filter in spec-filter.css) so it reads as part of the specs.
 *
 * Matching is token based and punctuation insensitive, so "max watt" finds
 * "Maximum Wattage per Bulb" and "e12" finds "E12 Candelabra".
 */
(function () {
  'use strict';

  var MIN_ROWS = 8;

  var SEARCH_ICON =
    '<svg aria-hidden="true" focusable="false" fill="none" viewBox="0 0 14 14">' +
    '<circle cx="6" cy="6" r="4.5" stroke="currentColor"></circle>' +
    '<path d="m9.5 9.5 3.5 3.5" stroke="currentColor" stroke-linecap="square"></path></svg>';

  var CLOSE_ICON =
    '<svg aria-hidden="true" focusable="false" fill="none" viewBox="0 0 12 12">' +
    '<path d="m1 1 10 10M1 11 11 1" stroke="currentColor" stroke-width="1.4"></path></svg>';

  function normalize(value) {
    return (value || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  }

  function init() {
    var root = document.getElementById('catalog-detail-info');
    if (!root || root.dataset.specFilterReady === 'true') return;

    var rows = Array.prototype.slice.call(root.querySelectorAll('.card-body .row'));
    if (rows.length < MIN_ROWS) return;

    root.dataset.specFilterReady = 'true';

    var cards = Array.prototype.slice.call(root.querySelectorAll('.card'));
    var keys = rows.map(function (row) { return normalize(row.textContent); });

    var wrap = document.createElement('div');
    wrap.className = 'spec-filter';
    wrap.innerHTML =
      '<button type="button" class="spec-filter__toggle animate-link" aria-expanded="false" aria-controls="spec-filter-panel">' +
      SEARCH_ICON + 'Find a spec</button>' +
      '<div class="spec-filter__panel" id="spec-filter-panel" hidden>' +
      '<div class="spec-filter__field">' +
      '<span class="spec-filter__icon">' + SEARCH_ICON + '</span>' +
      '<label class="sr-only" for="spec-filter-input">Search specifications</label>' +
      '<input id="spec-filter-input" class="spec-filter__input" type="text" inputmode="search"' +
      ' autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false"' +
      ' placeholder="Wattage, dimmable, width…">' +
      '<button type="button" class="spec-filter__close" aria-label="Close spec search">' + CLOSE_ICON + '</button>' +
      '</div>' +
      '<p class="spec-filter__count" aria-live="polite"></p>' +
      '</div>';

    root.parentNode.insertBefore(wrap, root);
    root.classList.add('has-spec-filter');

    var empty = document.createElement('p');
    empty.className = 'spec-filter__empty h6';
    empty.hidden = true;
    root.parentNode.insertBefore(empty, root.nextSibling);

    var toggle = wrap.querySelector('.spec-filter__toggle');
    var panel = wrap.querySelector('.spec-filter__panel');
    var input = wrap.querySelector('.spec-filter__input');
    var closeButton = wrap.querySelector('.spec-filter__close');
    var count = wrap.querySelector('.spec-filter__count');

    function apply() {
      var query = normalize(input.value);
      var terms = query ? query.split(' ') : [];
      var shown = 0;

      rows.forEach(function (row, index) {
        var match = terms.every(function (term) { return keys[index].indexOf(term) !== -1; });

        if (match) {
          row.removeAttribute('data-spec-hidden');
          shown++;
        } else {
          row.setAttribute('data-spec-hidden', '');
        }
      });

      cards.forEach(function (card) {
        if (card.querySelector('.card-body .row:not([data-spec-hidden])')) {
          card.removeAttribute('data-spec-hidden');
        } else {
          card.setAttribute('data-spec-hidden', '');
        }
      });

      if (!terms.length) {
        count.textContent = '';
        empty.hidden = true;
        return;
      }

      count.textContent = shown + ' of ' + rows.length;
      empty.hidden = shown !== 0;
      if (!shown) empty.textContent = 'No specifications match “' + input.value.trim() + '”.';
    }

    function open() {
      toggle.hidden = true;
      panel.hidden = false;
      wrap.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      input.focus();
    }

    function close() {
      input.value = '';
      apply();
      panel.hidden = true;
      toggle.hidden = false;
      wrap.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.focus();
    }

    var timer;

    toggle.addEventListener('click', open);
    closeButton.addEventListener('click', close);

    input.addEventListener('input', function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(apply, 90);
    });

    input.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      event.preventDefault();

      if (input.value) {
        input.value = '';
        apply();
      } else {
        close();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
